/* globals location */
export default (state, update) => update;
